import React from 'react'

import Body from './Body'
import Title from './Title'

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * If `true`, the alert will be a Danger Alert.
   */
  danger?: boolean
}

const Alert: React.FC<Props> = ({ children, danger }) => (
  <div
    role="alert"
    className={`relative inline-block p-5 rounded-lg ${
      danger ? 'bg-error-100' : 'bg-warning-100'
    }`}
  >
    <div
      className={`absolute text-xl font-bold -top-4 inline-flex h-8 w-8 rounded-full items-center justify-center ${
        danger ? 'bg-error-500 text-white' : 'bg-warning'
      }`}
    >
      !
    </div>
    {React.Children.map(children, (child) => {
      // Just pass the error prop if the children
      if (React.isValidElement(child)) {
        return React.cloneElement(child, { danger })
      }

      return child
    })}
  </div>
)

// Combined components to use dot notation
export default Object.assign<
  typeof Alert,
  { Title: typeof Title; Body: typeof Body }
>(Alert, {
  Title,
  Body,
})
